import React from 'react';

const ConversationLoading = () => (
    <>
        <div className="max-w-[76%] ml-auto">
            <div className="p-2 border border-utilityGray200 rounded-lg space-y-1.5">
                <div className="flex items-center gap-x-1.5">
                    <span className="custom-loading text-xs px-2 py-0.5 rounded-md border border-utilityGray200">Shipment Quote</span>
                </div>
                <span className="custom-loading text-gray500 text-xs leading-[1.5] font-normal block">Can you get me the best rate for this shipment?</span>
                <div className="custom-loading text-xs leading-[1.5] font-normal block">Need it shipped from Chicago to LA by Thursday. Pallet, ~500 lbs.</div>
                <span className="custom-loading text-xs block">2 minutes ago</span>
            </div>
        </div>

        <div className="max-w-[86%] ai-sender">
            <p className="text-grayLight900 text-xs leading-[1.5] font-normal custom-loading">I received your new quote request — pulling live rates from all connected carriers now.</p>
        </div>

        <ul className="mt-3">
            {[
                { title: 'Validating shipment details', items: ['Origin: Chicago, IL', 'Destination: Los Angeles, CA'] },
                { title: 'Querying carrier network', items: ['Checking 12 carriers…'] },
            ].map((step, i) => (
                <li
                    key={i}
                    className="flex gap-x-2 w-full pb-3 relative [&:not(:last-child)]:before:content-[''] [&:not(:last-child)]:before:absolute [&:not(:last-child)]:before:left-[7px] [&:not(:last-child)]:before:top-[18px] [&:not(:last-child)]:before:bottom-0 [&:not(:last-child)]:before:w-0.5 [&:not(:last-child)]:before:h-[calc(100%_-_16px)] [&:not(:last-child)]:before:bg-utilityGray200"
                >
                    <figure className="flex-shrink-0">
                        <div className="w-4 h-4 mt-0.5 rounded-full custom-loading" />
                    </figure>
                    <div className="space-y-1.5 flex-1 min-w-0">
                        <p className="truncate text-grayLight900 text-xs leading-[1.5] font-medium custom-loading">{step.title}</p>
                        <ul className="agent-message-stepper-lists">
                            {step.items.map((item, j) => (
                                <li key={j} className="agent-message-stepper-list-text">
                                    <span className="custom-loading">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </li>
            ))}
        </ul>

        <div className="max-w-[76%] ai-sender">
            <div className="p-2 border border-utilityGray200 rounded-lg bg-gray-50 space-y-1.5">
                <div className="flex items-center gap-x-1.5">
                    <span className="custom-loading text-xs px-2 py-0.5 rounded-md border border-utilityGray200">Draft</span>
                </div>
                <span className="text-gray500 text-xs font-normal leading-[1.5] custom-loading block">Rate Request — Chicago to LA</span>
                <div className="text-xs leading-[1.5] font-normal text-grayLight900 custom-loading">Hi, I am reaching out to request a quote for an LTL shipment…</div>
                <span className="custom-loading text-xs block">Sending…</span>
            </div>
        </div>
    </>
);

export default ConversationLoading;
